import { Injectable, signal, WritableSignal } from '@angular/core';
import { TableComponent } from '@components/base-components/table-components/table/table.component';

@Injectable({
  providedIn: 'root',
})
export class TableConductorService {
  activeTable: WritableSignal<TableComponent | null> = signal(null);

  tables: WritableSignal<{ [tableName: string]: TableComponent }[]> = signal([]);

  addTable(name: string, table: TableComponent) {
    const tables = this.tables();
    const existingTable = tables.find((t) => t[name]);
    if (existingTable) {
      existingTable[name] = table;
    } else {
      this.tables.update((prev) => [...prev, { [name]: table }]);
    }
  }

  removeTable(name: string) {
    this.tables.update((prev) => prev.filter((t) => !t[name]));
  }

  updateTable(name: string) {
    const existingTable = this.tables().find((t) => t[name]);
    if (existingTable) {
      const table = existingTable[name];
      if (table) {
        table.baseTableService.getData();
      }
    }
  }
}
